import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SavingsObjective, UpsertSavingsObjectiveRequest } from '@core/models';
import { endpoints, environment } from '@environment';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';

@Injectable({ providedIn: 'root' })
export class SavingsObjectiveService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.savingsObjective}`;

  get(): Observable<SavingsObjective | null> {
    return this.http.get<SavingsObjective | null>(this.baseUrl, { context: suppressGlobalErrorFeedback() });
  }

  update(payload: UpsertSavingsObjectiveRequest): Observable<SavingsObjective> {
    return this.http.put<SavingsObjective>(this.baseUrl, payload, { context: suppressGlobalErrorFeedback() });
  }
}
